import script from "./ScormPreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ScormPreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./ScormPreviewModal.vue?vue&type=style&index=0&id=9490af7c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9490af7c"]])

export default __exports__